import React from 'react'
import { FaInstagram, FaLinkedinIn, FaTwitter, FaWhatsapp } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const Footer = () => {
    const gotoSection = (page, section) =>{
        console.log(page, section)
        const sectionEl = document.getElementById(section)

        sectionEl.scrollIntoView()
    }
  return (
    <div className='footer'>
        <div className="social-links">
                <h3>Follow Us</h3>
                <div className="links-holder">
                    <Link to={"/"}>
                        <FaWhatsapp />
                    </Link>
                    <Link to={"/"}>
                        <FaInstagram />
                    </Link>
                    <Link to={"/"}>
                        <FaTwitter />
                    </Link>
                    <Link to={"/"}>
                        <FaLinkedinIn />
                    </Link>
                </div>
            </div>
            <div className="company">
                <h3>Company</h3>
                <div className="links-holder">
                    <Link to={"/"}>
                        <p>
                            Home
                        </p>
                    </Link>
                    <Link to={"/shop"}>
                        <p>
                            Shop
                        </p>
                    </Link>
                    <Link to={"/"} onClick={()=>{
                        gotoSection("home", "about-us")
                    }}>
                        <p>
                            About Us
                        </p>
                    </Link>
                    <Link to={"/"} onClick={()=>{
                        gotoSection("home", "contact-us")
                    }}>
                        <p>
                            Contact Us
                        </p>
                    </Link>
                </div>
            </div>
            <div className="resources">
                <h3>Resources</h3>
                <div className="links-holder">
                    <Link to={"/faqs"}>
                        <p>
                            Faq
                        </p>
                    </Link>
                    <Link href="" target="_blank" rel='noreferrer'>
                        <p>
                            Help & Support
                        </p>
                    </Link>
                </div>
            </div>
            <div className="legal">
                <h3>Legal</h3>
                <div className="links-holder">
                    <Link to={"/terms"}>
                        <p>
                            Terms & Conditions
                        </p>
                    </Link>
                    <Link to={"/privacy"}>
                        <p>
                            Privacy Policy
                        </p>
                    </Link>
                </div>
            </div>
        <div className="copyright">
            <p>
                © 2022 Shoptinga inc. All Rights Reserved.
            </p>
        </div>

    </div>
  )
}

export default Footer